import { jsx as s } from "react/jsx-runtime";
const b = (t) => {
  const { onSubmitValues: e, filterEmptyValues: m, ...u } = t;
  return /* @__PURE__ */ s("form", { onSubmit: (o) => {
    if (o.preventDefault(), e) {
      const a = new FormData(o.currentTarget).entries();
      let r = {};
      for (const [i, n] of a)
        m && !n || (r = { ...r, [i]: n });
      e(r);
    }
    t.onSubmit && t.onSubmit(o);
  }, ...u });
};
export {
  b as Form
};
